import React from "react";

/**
 * A crash should say so.
 *
 * Without this, any exception during render leaves a blank white page:
 * no message, no way back, nothing to report. This catches it, says what
 * happened, and gives a way out.
 */
export default class Boundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }

  static getDerivedStateFromError(err) { return { err }; }

  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error("PostcardGolf crashed:", err, info?.componentStack);
  }

  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="centre">
        <div className="centre-box">
          <h1>Something went wrong</h1>
          <p>
            That page didn't load properly. It's a fault in the app rather
            than anything you did.
          </p>
          <div className="notice notice-error" style={{ marginBottom: "1.2rem" }}>
            {this.state.err.message ?? String(this.state.err)}
          </div>
          <button className="btn btn-primary btn-block"
                  onClick={() => { window.location.href = "/"; }}>
            Back to the start
          </button>
        </div>
      </div>
    );
  }
}
